
import React from 'react';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { EnterpriseCoreModule } from '@ag-grid-enterprise/core';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { GridChartsModule } from '@ag-grid-enterprise/charts';
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail';
    
import './styles.css';
import { AgGridReact } from '@ag-grid-community/react';
ModuleRegistry.registerModules([
  EnterpriseCoreModule,
  ClientSideRowModelModule,
  ServerSideRowModelModule,
  MenuModule,
  ColumnsToolPanelModule,
  SetFilterModule,
  RangeSelectionModule,
  GridChartsModule,
  MasterDetailModule
]);

declare const REACT_APP_AG_GRID_LICENSE_KEY: string;
LicenseManager.setLicenseKey(REACT_APP_AG_GRID_LICENSE_KEY ?? '');

export { AgGridReact as ReactGrid };

// export default AgGridReact;
// Export types
export type {
  CellClickedEvent,
  RowClickedEvent,
  GridOptions,
  RowSelectedEvent,
  SelectionChangedEvent,
  ColDef,
  GridApi,
  GridReadyEvent,
  IHeaderParams,
  ICellRendererParams,
  IServerSideGetRowsParams,
  ITooltipParams,
  Component,
  ValueGetterParams,
  CellClassParams,
  CellStyle
} from 'ag-grid-community';
